import { newId } from "../ids.js";
import { isoString, systemClock, type Clock } from "../time.js";
import type { Topic, TopicInput } from "./types.js";

/** Build a new Topic record from user input. Pure: doesn't persist. */
export function createTopic(input: TopicInput, now: Clock = systemClock): Topic {
  const ts = isoString(now());
  return {
    id: newId(),
    name: input.name.trim(),
    parent_id: input.parent_id ?? null,
    color: input.color ?? null,
    icon: input.icon ?? null,
    owner_id: input.owner_id ?? null,
    created_at: ts,
    updated_at: ts,
    deleted_at: null,
  };
}
